import React, { useEffect, useState, useCallback, useMemo } from 'react';
import './index.css';
import { DashBoardTitle } from '../../Title';
import Pagination from '../../Pagination/Pagination';
import CustomSpinner from '../../CustomSpinner/CustomSpinner';
import edit from '../../../images/edit.png';
import { getDealerActiveInActiveWithStatus } from '../../../constants/apiCalls';
import closeImg from '../../../assets/img/close.png';
import { Col, Container, Row, Modal, ModalBody, Table, UncontrolledTooltip } from 'reactstrap';
import { PreviewAppModal } from '../../../Pages/Registeration';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import Storage from '../../../services/Storage';
import { Breadcrumbs } from '../../Breadcrumbs/Breadcrumbs';
import { BreadCrumbBackButton } from '../../Breadcrumbs/BreadCrumbBackButton';
import { UserFilters } from '../../Filters';
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../utils/utils';
import DateService from '../../../services/DateService';
import { CommonButton } from '../../CommonComponents';
import { messages } from '../../../utils/constant-messages';
import { Permissions } from '../../../constants/Permissions';
import { Roles } from '../../../constants/Roles';
import { useSelector } from 'react-redux';
import AppHeader from '../../../Layout/AppHeader';
import AppSidebar from '../../../Layout/AppSidebar';
import tableExcel from '../../../images/tableExcel.png';


export function DealerListActiveTable() {
  const params = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // const localPermission = Storage.getUserPermissionDetail();
  const { permissionArr } = useSelector(state => state.UserGetReducer)
  const localPermission = permissionArr;
  let userInfo = Storage.getUserInfoDetail();
  let roleName = userInfo ? userInfo.role : '';
  useEffect(() => {
    if (!localPermission.includes(Permissions.DEALER_LIST)) {
      navigate('/');
    }
  }, [...localPermission])

  let pageNo = useMemo(() => Storage.getDealerListPage(), [Storage.getDealerListPage()]);
  const [object, setObject] = useState({});
  const [dealerData, setDealerData] = useState([]);
  const [Id, setId] = useState('');
  const [isCreditLimitModal, setIsShowCreditLimit] = useState(false);

  // Page
  const [count, setCount] = useState(0);
  const [tabCounts, setTabCounts] = useState({
    pending: 0,
    completed: 0,
  });
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(Number(pageNo) ? Number(pageNo) : 1);
  const [pageSize, setPageSize] = useState(10);

  // Date
  const [isLoading, setIsloading] = useState(false);
  const [modalPreview, setModalPreview] = useState(false);
  // const [isShowTabs, setShowTabs] = useState(roleName === Roles.CNF_ROLE);
  const isShowTabs=roleName === Roles.CNF_ROLE;
  const [tabName, setTabName] = useState('pending');
  const [dealerDetail,setDealerDetail] = useState({});

  let userDataAll = Storage.getBreadcrumbsrRecord();
  let userData = useMemo(
    () =>
      userDataAll.reduce((unique, o) => {
        if (!unique.some((obj) => obj.id === o.id && obj.role === o.role)) {
          if (o.filter) {
            unique.push(o.filter);
          }
        }
        return unique;
      }, []),
    []
  );

  useEffect(() => { }, [userData]);

  const setBreadcrumbsRecord = () => {
    Storage.setBreadcrumbsrRecord([
      {
        title: 'Dealer List',
        url: location.pathname,
      },
    ]);
  };

  const getDealerData = useCallback(
    (obj, page, pageSize,tab=null) => {
      setIsloading(true);
      setObject(obj);
      let payload = {
        q: obj.searchQuery || '',
        pagesize: pageSize,
        page: page || 1,
        status: obj.statusVal ? obj.statusVal : '',
        // start_date: obj.startDate ? obj.startDate : '',
        // end_date: obj.endDate ? obj.endDate : '',
        nh: obj.nhId || null,
        sh: obj.shId || null,
        th: obj.tmId || null,
        state_id: obj.stateId || null,
        territory_id: obj.territoryId || null,
        iskycrequire: obj.kyc ? obj.kyc : '',
        is_download: false,
      };
      if(isShowTabs) {
        if(tab === 'pending' || (!tab && tabName === 'pending')) {
          payload.is_confirm_cheques = false;
        } else if(tab === 'completed' || (!tab && tabName === 'completed')) {
          payload.is_confirm_cheques = true;
        }
      }
      getDealerActiveInActiveWithStatus((res) => {
        const { data, success, error } = res;
        if (success === true) {
          setDealerData(data.data);
          let count = data.total_count;
          setCount(count);
          let totalPages = Math.ceil(count / pageSize);
          setTotalPages(totalPages);
          setIsloading(false);
          setTabCounts({
            pending: data.pending_count || 0,
            completed: data.completed_count || 0,
          })
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
      }, payload);
    },
    [object, page, pageSize]
  );

  const handleExcelSheet = useCallback(
    (obj, page, pageSize,tab) => {
      let payload = {
        q: obj.searchQuery || '',
        pagesize: 100000,
        page: page || 1,
        status: obj.statusVal ? obj.statusVal : '',
        // start_date: obj.startDate ? obj.startDate : '',
        // end_date: obj.endDate ? obj.endDate : '',
        nh: obj.nhId || null,
        sh: obj.shId || null,
        th: obj.tmId || null,
        state_id: obj.stateId || null,
        territory_id: obj.territoryId || null,
        iskycrequire: obj.kyc ? obj.kyc : '',
        is_download: true,
      };
      if(isShowTabs) {
        if(tab === 'pending' || (!tab && tabName === 'pending')) {
          payload.is_confirm_cheques = false;
        } else if(tab === 'completed' || (!tab && tabName === 'completed')) {
          payload.is_confirm_cheques = true;
        }
      }
      getDealerActiveInActiveWithStatus((res) => {
        const { data, success, error } = res;
        if (success === true) {
          window.open(data.file, '_blank');
          setIsloading(false);
        } else if (success === false || success === 'undefined') {
          setIsloading(false);
          ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
        }
        setIsloading(false);
      }, payload);
    },
    [object, page, pageSize]
  );

  const handlePageChange = useCallback(
    (page) => {
      setPage(page);
      Storage.setDealerListPage(Number(page));
      getDealerData(object, page, pageSize);
    },
    [object, page, pageSize]
  );

  const handleInputChange = useCallback(
    (e) => {
      let pageSize = parseInt(e.target.value);
      setPageSize(pageSize);
      setPage(1);
      getDealerData(object, page, pageSize);
    },
    [object, page, pageSize]
  );
  const togglePreviewApp = (val, isCreditLimitModal) => {
    // setBreadcrumbsRecord();
    setId(val);
    setIsShowCreditLimit(isCreditLimitModal);
    setModalPreview(!modalPreview);
  };

  const handleTabChange = useCallback(
    (tab) => {
      setTabName(tab);
      setObject({});
      setPage(1);
      getDealerData(object, page, pageSize,tab);
    },
    [object, page, pageSize]
  );

  return (
    <>
      <AppHeader />
      <div className='app-main'>
        <AppSidebar />
        <div className='app-main__outer'>
          <div className='app-main__inner rms-wrapper'>
            <div id='dealerListActiveTable'>
              {isLoading && <CustomSpinner />}
              <div className='pageWrapper'>
                <Container fluid>
                  <Row>
                    <Col xs={12}>
                      <div className='pageheader'>
                       {
                        roleName === Roles.CNF_ROLE?
                        <DashBoardTitle
                        dashBorardName={`Dealer List`}
                      />: <DashBoardTitle
                      dashBorardName={`Dealer List ${params.pagetype.includes('inactive') ? 'inActive' : 'Active'
                        }`}
                    />
                       }
                        {!modalPreview && <BreadCrumbBackButton />}
                      </div>
                    </Col>
                    <Col xs={12}>
                      {!modalPreview && <Breadcrumbs title='Dealer List' />}
                    </Col>
                    <Col xs={12}>
                      <UserFilters
                        page={page}
                        setPage={setPage}
                        pageSize={pageSize}
                        setPageSize={setPageSize}
                        pageNo={pageNo}
                        userData={userData}
                        // startDate={startDate}
                        // setStartDate={setStartDate}
                        // endDate={endDate}
                        // setEndDate={setEndDate}
                        dealerData={getDealerData}
                        excelData={handleExcelSheet}
                      />
                    </Col>
                     {
                      isShowTabs &&
                      <Col xs={12}>
                        <CommonButton name={tabCounts.pending && tabName === 'pending'?`Cheques Pending (${tabCounts.pending})`:'Cheques Pending'} btnClass={tabName === 'pending' ? 'btnPrimary' : 'btnTernary'} maxWidth='175px' type="button" onClick={(e) => {
                        handleTabChange('pending');
                      }} />
                        <CommonButton name={`Cheques Received`} btnClass={ tabName === 'completed'? 'btnPrimary' : 'btnTernary'} maxWidth='175px' type="button" onClick={(e) => {
                        handleTabChange('completed');
                      }} />
                              {/* <CommonButton name={`Pending`} btnClass={tabName === 'pending' ? 'btnPrimary' : 'btnTernary'} maxWidth='175px' type="button" onClick={(e) => {
                        handleTabChange('pending');
                      }} />
                        <CommonButton name={`Completed`} btnClass={ tabName === 'completed'? 'btnPrimary' : 'btnTernary'} maxWidth='175px' type="button" onClick={(e) => {
                        handleTabChange('completed');
                      }} /> */}
                      <img
                        src={tableExcel}
                        style={{ cursor: 'pointer',marginLeft:'2%'}}
                        className="excelImg"
                        alt="excel"
                        id="Tooltip-Download-Dealer"
                        onClick={() => handleExcelSheet(object, page, pageSize,tabName)}
                      />
                        <UncontrolledTooltip placement="right" target={'Tooltip-Download-Dealer'}>
                            Download {tabName === 'pending'?'Cheques Pending':'Cheques Received'} Dealers
                        </UncontrolledTooltip>
                     </Col>
                     }
                      
                  </Row>
                  {dealerData.length && count > 0 ? (
                    <Row>
                      <Col xs={12}>
                        <div className='table-responsive dealerTable'>
                          <Table bordered className='table text-center'>
                            <thead>
                              <tr>
                                <th>Dealer Code</th>
                                <th>Dealership Name</th>
                                <th>Owner Name</th>
                                <th>Mobile</th>
                                <th>Credit Limit</th>
                                <th>Last CL Set Date</th>
                                <th>Risk Measure Tag</th>
                                {roleName === Roles.TM_NAME && <th>City/Town</th>}
                                <th>Territory</th>
                                <th>State</th>
                                {roleName === Roles.BH_NAME && <th>NH</th>}
                                {(roleName === Roles.NH_NAME ||
                                  roleName === Roles.BH_NAME) && <th>SH</th>}
                                {roleName !== Roles.TM_NAME && <th>TM</th>}
                                <th>Status</th>
                                {roleName === Roles.SH_NAME || roleName === Roles.TM_NAME ? <th>Action</th> : ''}
                              </tr>
                            </thead>
                            <tbody>
                              {dealerData.map((elem, index) => {
                                const {
                                  id,
                                  dealer_code,
                                  business_name,
                                  is_required_kyc,
                                  primary_contact_name,
                                  primary_contact_mobile,
                                  city,
                                  territory,
                                  state,
                                  tm,
                                  status,
                                  credit_limit,
                                  risk_measure_tag,
                                  last_credit_limit_set_date,
                                  nh,
                                  sh,
                                } = elem;
                                return (
                                  <tr key={index}>
                                    <td>{dealer_code}</td>
                                    <td>
                                      <span
                                        className='dealershipLink'
                                        onClick={() => {
                                          togglePreviewApp(id)
                                          setDealerDetail(elem)
                                        }}
                                      >
                                        {business_name}
                                      </span>
                                    </td>
                                    <td>{primary_contact_name}</td>
                                    <td>{primary_contact_mobile}</td>
                                    <td>
                                      {credit_limit ? (
                                        <div className='d-flex justify-content-center align-items-center'>
                                          {credit_limit}
                                          {/* <img src={edit} alt="edit"
                                      style={{ cursor: "pointer" }}
                                      className="editIcon" onClick={() => togglePreviewApp(id, true)} /> */}
                                        </div>
                                      ) : (
                                        <div className='text-center'>N/A</div>
                                      )}
                                    </td>
                                    <td>{DateService.localDateOnly(last_credit_limit_set_date) || 'N/A'}</td>
                                    <td>{risk_measure_tag}</td>
                                    {roleName === Roles.TM_NAME && <td>{city}</td>}
                                    <td>{territory}</td>
                                    <td>{state}</td>
                                    {roleName === Roles.BH_NAME && <td>{nh}</td>}
                                    {(roleName === Roles.NH_NAME ||
                                      roleName === Roles.BH_NAME) && <td>{sh}</td>}
                                    {roleName !== Roles.TM_NAME && <td>{tm}</td>}
                                    <td>{status}</td>
                                    {(roleName === Roles.SH_NAME) || roleName === Roles.TM_NAME ? (
                                      <td>
                                        <div className='d-flex align-items-center justify-content-center'>
                                          {((roleName === Roles.TM_NAME && is_required_kyc) || (roleName === Roles.SH_NAME && is_required_kyc)) ? (
                                            <CommonButton name={'KYC'} btnClass={'btnPrimary kycBadge'} type="button" maxWidth='50px'
                                              onClick={() => {
                                                setBreadcrumbsRecord();
                                                navigate(`/pages/kyc/${id}`);
                                              }}
                                            />
                                          ) : (
                                            <img
                                              src={edit}
                                              alt='editIcon'
                                              className='iconImg cursorPointer'
                                              onClick={() => togglePreviewApp(id)}
                                            />
                                          )}
                                        </div>
                                      </td>
                                    ) : ''}

                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                      <Col xs={12}>
                        <div className='paginationWrapper'>
                          <span className='page-select-title'>Rows per page:</span>
                          &nbsp;&nbsp;
                          <select
                            className='form-control rows-per-page-select'
                            name='pageSize'
                            value={pageSize}
                            onChange={(e) => handleInputChange(e)}
                          >
                            <option key='5' value='5'>
                              5 Rows
                            </option>
                            <option key='10' value='10'>
                              10 Rows
                            </option>
                            <option key='15' value='15'>
                              15 Rows
                            </option>
                            <option key='20' value='25'>
                              25 Rows
                            </option>
                            <option key='25' value='30'>
                              30 Rows
                            </option>
                            <option key='30' value='50'>
                              50 Rows
                            </option>
                          </select>
                          &nbsp;&nbsp;
                          <div className='pageList'>
                            <Pagination
                              margin={2}
                              page={page}
                              count={parseInt(totalPages)}
                              pageSize={pageSize}
                              totalRecords={parseInt(count)}
                              onPageChange={handlePageChange}
                            ></Pagination>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col xs={12}>
                        {messages.COMMON.NO_RECORD_MATCH}
                      </Col>
                    </Row>
                  )}
                </Container>
              </div>

              {/* preview Modal */}
              <Modal
                id='preview-modal-dealerActive'
                isOpen={modalPreview}
                toggle={togglePreviewApp}
                className='previewAppModal'
                centered
              >
                <ModalBody className='pl-0 pr-0'>
                  <Container fluid>
                    <Row>
                      <Col xs={12}>
                        <div className='modalHeading'>
                          <div className='title leftTitle'>Preview App</div>
                          <div className='closeButton'>
                            <img
                              src={closeImg}
                              alt='close'
                              onClick={() => setModalPreview(!modalPreview)}
                            />
                          </div>
                        </div>
                      </Col>
                      <Col xs={12}>
                        <PreviewAppModal
                          userId={Id}
                          showButtons={roleName !== Roles.CNF_ROLE}
                          notProposedCreditLimit={true}
                          isCreditLimitModal={isCreditLimitModal}
                          hideComponents={modalPreview}
                          propShowDocument={roleName === Roles.CNF_ROLE}
                          reloadDealerList={()=>{getDealerData(object, page, pageSize);}}
                        />

                      </Col>
                    </Row>
                    <Row className='justify-content-center'>
                      <CommonButton name={'Close'} btnClass={'btnPrimary'} type="button" onClick={() => setModalPreview(!modalPreview)} />
                    </Row>
                  </Container>
                </ModalBody>
              </Modal>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
